var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-summary',{on:{"click":_vm.cancel}},[_vm._v(" E-Mail-Adresse: "),_c('strong',[_vm._v(_vm._s(_vm.state.value.username))])])}
var staticRenderFns = []

export { render, staticRenderFns }